export   const getData2 = async  (getdashBoardApi,setDashboard) => {
    try {
      const res = await getdashBoardApi();
      setDashboard(res?.data);
    } catch (err) {}
  };